import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../css/FloatButtonSupport.css'

const FloatButtonSupport = ({ to = '/app/send-mail-support', email = 'soporte@waretek.mx' }) => {
    return (
      <OverlayTrigger
        trigger={["hover", "hover"]}
        placement="left"
        overlay={
          <Popover className="popsupport">
            <strong>¿Necesitas ayuda?</strong> Click para enviarnos un correo a <strong>{ email }</strong>
          </Popover>
        }
      >
        <Link to={ to } className="float">
          <FontAwesomeIcon className='my-float' icon={ ['fas', 'envelope'] } />
        </Link>
      </OverlayTrigger>
    );
}

export default FloatButtonSupport;